'use strict';

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.factory("obsUtils", function ($numberFormat, $translate) {

    /**
     * dernière année des données de la DGFIP. A augmenter après chaque récupération annuelle.
     */
    var DERNIERE_ANNEE_DGFIP_DISPONIBLE = 2025;

    var obsUtils = {
        getStrateLabel: function (strate) {
            switch (strate) {
                case "MOINS_DE_500_HAB" :
                    return "- de 500 hab.";
                case "DE_500_A_2000_HAB" :
                    return "500 à 2000 hab.";
                case "DE_2000_A_3500_HAB" :
                    return "2 000 à 3 500 hab.";
                case "DE_3500_A_5000_HAB" :
                    return "3 500 à 5 000 hab.";
                case "DE_5000_A_10000_HAB" :
                    return "5 000 à 10 000 hab.";
                case "DE_10000_A_20000_HAB" :
                    return "10 000 à 20 000 hab.";
                case "DE_20000_A_50000_HAB" :
                    return "20 000 à 50 000 hab.";
                case "DE_50000_A_100000_HAB" :
                    return "50 000 à 100 000 hab.";
                case "PLUS_DE_100000_HAB_HORS_PARIS" :
                    return "+ de 100 000 hab..";
                case "HORS_STRATES" :
                    return null;

            }
            return "Strate inconnue :" + strate;
        },

        getTypeLabel: function (datatype) {
            switch (datatype) {
                case "POPULATION_DGFIP" :
                    return "Population (DGFiP)";
                case "POPULATION_INSEE" :
                    return "Population  (INSEE)";
                case "POPULATION_DGCL_DGF" :
                    return "Population (DGF)";
                case "ENCOURS_DETTE" :
                    return "Dette";
                case "ENCOURS_DETTE_PAR_HABITANT" :
                    return "Dette par habitant";
                case "ANNUITE_DETTE" :
                    return "Annuité";
                case "ANNUITE_DETTE_PAR_HABITANT" :
                    return "Annuité par habitant";
                case "AMORTISSEMENT_DETTE" :
                    return "Amortissement";
                case "AMORTISSEMENT_DETTE_PAR_HABITANT" :
                    return "Amortissement par habitant";
                case "INTERET_DETTE" :
                    return "Intérêt";
                case "INTERET_DETTE_PAR_HABITANT" :
                    return "Intérêt par habitant";
                case "DOTATIONS" :
                    return "Dotation globale de fonctionnement";
                case "DOTATIONS_PAR_HABITANT" :
                    return "Dotation globale de fonctionnement par habitant";
                case "POTENTIEL_FINANCIER_PAR_HABITANT" :
                    return "Potentiel financier par habitant";
                case "DETTE_SUR_POTENTIEL_FINANCIER" :
                    return "Dette sur potentiel financier";
                case "RECETTES_FONCTIONNEMENT" :
                    return "Recette de fonctionnement";
                case "RECETTES_FONCTIONNEMENT_PAR_HABITANT" :
                    return "Recette de fonctionnement par habitant";
                case "DETTE_SUR_RECETTES_FONCTIONNEMENT" :
                    return "Dette sur recette de fonctionnnement";

                // sytale
                case "ACTIVITES" :
                    return "Dernière activités clotûrée";
                case "PRESTATAIRE_DETTE" :
                    return "Prestataire dette";
            }

            return $translate('of.indicateur.' + datatype);
        },

        getTypeUnit: function (datatype, parHabitant) {
            switch (datatype) {
                case "POPULATION_DGFIP" :
                    return "habitants";
                case "POPULATION_INSEE" :
                    return "habitants";
                case "POPULATION_DGCL_DGF" :
                    return "habitants";
                case "DETTE_SUR_POTENTIEL_FINANCIER" :
                    return "mois";
                case "DETTE_SUR_RECETTES_FONCTIONNEMENT" :
                    return "mois";

                case  "TAXE_HABITATION_TAUX":
                    return "%";
                case  "TAXE_FONCIERE_NON_BATIE_TAUX":
                    return "%";
                case  "COTISATION_FONCIERE_ENTREPRISES_TAUX":
                    return "%";
                case  "TAXE_FONCIERE_BATIE_TAUX":
                    return "%";
                case  "TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX":
                    return "%";

                case "ACTIVITES" :
                    return " jours";
                case "PRESTATAIRE_DETTE" :
                    return "";

            }

            if (parHabitant) return "€/hab.";

            return "€";
        },

        formatValue: function formatValue(params, dataValue) {
            var formattedValue;
            var number = $numberFormat(dataValue);

            if (dataValue == null) {
                formattedValue = "Donnée non disponible";
            } else if (dataValue === "HORS_FILTRE") {
                formattedValue = "Hors filtre";
            } else {
                if (params.unite === 'POURCENTAGE') {
                    formattedValue = number + " %";
                } else {
                    if (params.representation === 'RELATIF' || params.temporalite === 'EVOLUTION') {
                        formattedValue = (dataValue > 0 ? "+" : "") + number + " " + obsUtils.getTypeUnit(params.datatype, params.parHabitant);
                    } else {
                        formattedValue = number + " " + obsUtils.getTypeUnit(params.datatype, params.parHabitant);
                    }
                }
            }
            return formattedValue;
        },

        getDerniereAnneeDispo: () => {
            return DERNIERE_ANNEE_DGFIP_DISPONIBLE;
        },

        /**
         * annees des indicateurs disponibles, hors Potentiel fiscal qui n'a pas les memes disponibilités.
         */
        getAnneesDispo: (type) => {
            let anneesDefaut = [];

            if (type === 'sdis') {
                for (let i = 2010; i <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; i++) {
                    anneesDefaut.push(i);
                }
            } else if (type === 'departement') {
                for (let i = 2008; i <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; i++) {
                    anneesDefaut.push(i);
                }
            } else {
                for (let i = 2000; i <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; i++) {
                    anneesDefaut.push(i);
                }
            }

            return anneesDefaut;
        }
    };

    return obsUtils;
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/utils/obsUtils.js